import { apiUrl }  from "../constants";
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class LeaguesApi {
    static getAll() {
        return request.get(`/leagues/${localStorage.getItem("rol")}`);
    }

    static get(id) {
        console.log("ROL:"+localStorage.getItem("rol"))
        console.log("ID")
        console.log(id)
        return request.get(`/leagues/${localStorage.getItem("rol")}/${id}`);
    }

    static getAllByTournament(id) {
        return request.get(`/leagues/getByTournament/${localStorage.getItem("rol")}/`+id);
    }

    static create(league) {
        return request.post(`/leagues`,{league: league });
    }

    static edit(league, id){
        console.log(league)
        return request.put(`/leagues/${id}`, {league: league});
    }

    static delete(id){
        return request.delete(`leagues?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Leagues.js